import { omdApi } from 'bus/api';

import { PayloadRequest } from 'types/requestTypes';

import { Account, AccountCreate, AccountEdit, AccountHistory, AccountResetPassword } from '../Accounts.entity';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getAccountDetail: builder.query<Account, PayloadRequest>({
      query: (data) => ({
        url: `/v1/Account/${data.id}`,
      }),
    }),
    changeAccount: builder.mutation<void, AccountEdit>({
      query: (data) => ({
        url: '/v1/Account/',
        method: 'PUT',
        body: data,
        params: { id: data.id },
      }),
    }),
    createAccount: builder.mutation<void, AccountCreate>({
      query: (data) => ({
        url: '/v1/Account',
        method: 'POST',
        body: data,
      }),
    }),
    resetPasswordAccount: builder.mutation<void, AccountResetPassword>({
      query: (data) => ({
        url: `/v1/Account/${data.id}/resetPassword`,
        method: 'POST',
        body: data,
      }),
    }),
    blockAccount: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/Account/${data.id}/block`,
        method: 'POST',
      }),
    }),
    getAccountHistory: builder.query<Array<AccountHistory>, PayloadRequest>({
      query: (data) => ({
        url: `/v1/Account/${data.id}/history`,
      }),
    }),
  }),
});

export const {
  useBlockAccountMutation,
  useChangeAccountMutation,
  useCreateAccountMutation,
  useGetAccountDetailQuery,
  useLazyGetAccountDetailQuery,
  useResetPasswordAccountMutation,
  useGetAccountHistoryQuery,
} = request;
